import '../../httpservices/core/ajax.httpservice.core';

class InsuranceHttpService {

    GetPageInitData() {
        return $.get('Patient/Insurance/GetPageInitData');
    }

    FormEditInitData() {
        return $.get('Patient/Insurance/FormEditInitData');
    }

    //model = FormEditValidateInsurance.cs
    ValidateInsuranceRecord(model) {
        return $.post('Patient/Insurance/FormEditValidateInsurance', model);
    }

    //model = List<FormEditValidateInsurance.cs>
    ValidateAndGetChanges(listOfUpdatedRecords) {
        return $.post('Patient/Insurance/ValidateAndGetChanges', listOfUpdatedRecords);
    }

    //model is a NonMskDoctorViewModel.cs
    GetDeltaChange(model) {
        return $.post('Patient/Insurance/GetDeltaChange', model);
    }

    //model is a List of NonMskDoctorViewModel.cs
    GetDeltaChanges(model) {
        return $.post('Patient/Insurance/GetDeltaChanges', model);
    }

    GetInsurancesAuthorization() {
        return $.get('Patient/Insurance/GetInsurancesAuthorization');
    }

    GetInsurancesAuthorizationContent() {
        return $.get('Patient/Insurance/GetInsurancesAuthorizationContent');
    }

    //model = List<FormEditValidateInsurance.cs>
    //CommitAllChanges(listOfUpdatedRecords, priorityRecords, medicareQuestions) {
    //    return $.post('Patient/Insurance/CommitAllChanges',
    //        {
    //            updatedOrAddedRecords: listOfUpdatedRecords,
    //            priorityRecords: priorityRecords,
    //            medicareQuestions: medicareQuestions
    //        });
    //}

    CommitAllChanges(arrayOfRecords) {
        return $.post('Patient/Insurance/CommitAllChanges', { insuranceModel: arrayOfRecords});
    }

}

export const InsuranceHttpSvc = new InsuranceHttpService();